<template>
    <div class="af-search-container afu-bg-custom-searchbarbg">
        <div class="af-search-results-container afu-w-full afu-max-w-screen-xl afu-ml-auto afu-mr-auto af-search-results-container">
            <SearchBar @search="onSearch" />
            <FilterTagsList @search="onSearch" />
        </div>
        <div class="afu-bg-white">
            <div class="af-search-results-container afu-w-full afu-max-w-screen-xl afu-ml-auto afu-mr-auto">
                <hr class="afu-border afu-border-custom-divider afu-mb-6">
                <div
                    v-if="$_search.searchPayload.meta"
                    class="af-search-title"
                >
                    <h1 class="afu-mb-0 afu-text-sm afu-font-semibold">
                        {{ $te('raw.override_search_title') ? $t('raw.override_search_title') : $_search.searchPayload.meta.title }}
                    </h1>
                    <C1Alert
                        v-if="$_search.searchPayload.warning_message"
                        variant="danger"
                    >
                        <span v-html="getTranslatedMessage($_search.searchPayload.warning_message)" />
                    </C1Alert>
                </div>
                <div class="afu-flex afu-flex-wrap">
                    <div class="afu-w-3/12 afu-box-border">
                        <SearchResultSidebar @search="onSearch" />
                        <!-- load attribute skeleton -->
                        <template v-if="$_search.loading.jobs">
                            <div class="af-attribute-skeleton af-attribute-filter afu-my-4 afu-pt-5 afu-pb-2 afu-px-4 afu-shadow-secondary afu-rounded-secondary afu-border-neutral-light afu-bg-neutral-light">
                                <div class="afu-bg-gray-500 afu-w-20 afu-animate-pulse afu-h-4 afu-mb-4 afu-rounded-2xl" />
                                <div class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-3 afu-mb-3 afu-rounded-2xl" />
                                <div class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-3 afu-mb-3 afu-rounded-2xl" />
                                <div class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-3 afu-mb-3 afu-rounded-2xl" />
                                <div class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-3 afu-mb-3 afu-rounded-2xl" />
                                <div class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-3 afu-mb-3 afu-rounded-2xl" />
                            </div>
                            <div class="af-attribute-skeleton af-attribute-filter afu-my-4 afu-pt-5 afu-pb-2 afu-px-4 afu-shadow-secondary afu-rounded-secondary afu-border-neutral-light afu-bg-neutral-light">
                                <div class="afu-bg-gray-500 afu-w-20 afu-animate-pulse afu-h-4 afu-mb-4 afu-rounded-2xl" />
                                <div class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-3 afu-mb-3 afu-rounded-2xl" />
                                <div class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-3 afu-mb-3 afu-rounded-2xl" />
                                <div class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-3 afu-mb-3 afu-rounded-2xl" />
                                <div class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-3 afu-mb-3 afu-rounded-2xl" />
                                <div class="afu-bg-gray-400 afu-w-full afu-animate-pulse afu-h-3 afu-mb-3 afu-rounded-2xl" />
                            </div>
                        </template>
                        <!-- end attribute skeleton -->
                    </div>
                    <div class="afu-w-9/12 afu-pl-8 afu-box-border afu-mt-6">
                        <div class="af-search-header afu-flex afu-items-center afu-justify-between afu-mb-4">
                            <div 
                                class="af-search-info" 
                                v-if="$_jobsCount"
                            >
                                <template v-if="!$_search.loading.jobs">
                                    <C1PaginatorShowingResults
                                        :map-view="mapView"
                                        :per-page="paginator.per_page"
                                        :current-page="$_jobsSearchFilters.page"
                                        :total="mapView ? $_mapViewJobsCount : $_jobsCount"
                                    />
                                </template>
                            </div>
                            <div 
                                v-if="!$_search.loading.jobs"
                                class="af-search-actions afu-flex"
                            >
                                <SearchViewBtn
                                    v-if="isMapEnabled && $_jobsCount > 0"
                                    size="md"
                                    class="afu-mr-4"
                                    :view="mapView ? 'map' : 'list'"
                                    @click="toggleMapView"
                                />
                                <SaveSearch 
                                    :has-jobs="$_jobsCount > 0"
                                />
                                <SortSearch v-if="!mapView && $_jobsCount > 0" />
                            </div>
                        </div>
                        <!-- load job results skeleton -->

                        <template v-if="$_search.loading.jobs">
                            <template v-if="mapView">
                                <div class="afu-bg-white afu-rounded-2xl afu-shadow-lg afu-text-center afu-py-48 afu-animate-pulse">
                                    <FontAwesomeIcon
                                        :icon="['far', 'map-marked']"
                                        class="afu-text-neutral--light"
                                        size="3x"
                                    />
                                </div>
                            </template>
                            <template v-else>
                                <div class="afu-pb-3 afu-sm:p-4 afu-sm:h-64 afu-rounded-2xl afu-flex afu-flex-col afu-sm:flex-row afu-gap-5 afu-select-none afu-mb-3">
                                    <div class="afu-ml-auto afu-flex afu-gap-3">
                                        <div class="afu-bg-gray-200 afu-w-20 afu-h-8 afu-animate-pulse afu-rounded-full afu-ml-auto" />
                                        <div class="afu-bg-gray-200 afu-w-20 afu-h-8 afu-animate-pulse afu-rounded-full afu-ml-auto" />
                                    </div>
                                </div>
                                <div class="afu-bg-white afu-sm:h-64 afu-rounded-2xl afu-shadow-lg afu-flex afu-flex-col afu-sm:flex-row afu-gap-5 afu-select-none afu-mb-4">
                                    <div class="afu-flex afu-flex-col afu-flex-1 afu-gap-5 afu-sm:p-2">
                                        <div class="afu-flex afu-p-5 md:afu-p-6 afu-flex-1 afu-flex-col afu-gap-3">
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-10 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                        </div>
                                        <div class="afu-bg-gray-100 afu-mt-auto afu-px-6 md:afu-mt-2 afu-py-3 afu-flex afu-gap-3">
                                            <div class="afu-bg-gray-200 afu-w-full afu-h-8 afu-animate-pulse afu-rounded-full" />
                                            <div class="afu-bg-gray-200 afu-w-20 afu-h-8 afu-animate-pulse afu-rounded-full afu-ml-auto" />
                                        </div>
                                    </div>
                                </div>
                                <div class="afu-bg-white afu-sm:h-64 afu-rounded-2xl afu-shadow-lg afu-flex afu-flex-col afu-sm:flex-row afu-gap-5 afu-select-none afu-mb-4">
                                    <div class="afu-flex afu-flex-col afu-flex-1 afu-gap-5 afu-sm:p-2">
                                        <div class="afu-flex afu-p-5 md:afu-p-6 afu-flex-1 afu-flex-col afu-gap-3">
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-10 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                        </div>
                                        <div class="afu-bg-gray-100 afu-mt-auto afu-px-6 md:afu-mt-2 afu-py-3 afu-flex afu-gap-3">
                                            <div class="afu-bg-gray-200 afu-w-full afu-h-8 afu-animate-pulse afu-rounded-full" />
                                            <div class="afu-bg-gray-200 afu-w-20 afu-h-8 afu-animate-pulse afu-rounded-full afu-ml-auto" />
                                        </div>
                                    </div>
                                </div>
                                <div class="afu-bg-white afu-sm:h-64 afu-rounded-2xl afu-shadow-lg afu-flex afu-flex-col afu-sm:flex-row afu-gap-5 afu-select-none afu-mb-4">
                                    <div class="afu-flex afu-flex-col afu-flex-1 afu-gap-5 afu-sm:p-2">
                                        <div class="afu-flex afu-p-5 md:afu-p-6 afu-flex-1 afu-flex-col afu-gap-3">
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-10 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                            <div class="afu-bg-gray-200 afu-w-full afu-animate-pulse afu-h-3 afu-rounded-2xl" />
                                        </div>
                                        <div class="afu-bg-gray-100 afu-mt-auto afu-px-6 md:afu-mt-2 afu-py-3 afu-flex afu-gap-3">
                                            <div class="afu-bg-gray-200 afu-w-full afu-h-8 afu-animate-pulse afu-rounded-full" />
                                            <div class="afu-bg-gray-200 afu-w-20 afu-h-8 afu-animate-pulse afu-rounded-full afu-ml-auto" />
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <SearchResultMap
                                :jobs="$_jobs"
                                v-if="mapView"
                            />
                            <SearchResultLoop
                                :jobs="$_jobs"
                                v-else
                            />
                            <template
                                v-if="!mapView && $_jobsCount > paginator.per_page"
                            >
                                <C1Paginator
                                    :current-page="$_jobsSearchFilters.page"
                                    :total="$_jobsCount"
                                    :per-page="paginator.per_page"
                                    @change="changePage"
                                />
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { slugifyKey } from '@/utils/helpers';
    import SearchMixin from './Mixins/SearchMixin';

    export default {
        name: 'SearchResults',

        mixins: [SearchMixin],

        data() {
            return {

            };
        },
        methods: {

            getTranslatedMessage(msg) {
                const slugmsg = `raw.${slugifyKey(msg)}`;
                const translatedMsg = this.$t(slugmsg);
                return translatedMsg == slugmsg ? msg : translatedMsg;
            },
        },
    };
</script>

<style>

    .v-skeleton-loader__list-item-three-line {
        height: 99px;
    }

    .af-search-result-item .v-skeleton-loader__actions {
        float: right;
    }

    .af-search-result-item .v-skeleton-loader__button {
        border-radius: 0;
        height: 30px;
        width: 110px;
        margin: 5px 0;
    }

    .af-search-result-item .v-skeleton-loader__actions .v-skeleton-loader__button {
        display: block;
    }

    .v-skeleton-loader__heading {
        margin: 0 0 16px;
    }

    .v-skeleton-loader__text {
        margin: 0 0 16px;
    }

</style>
